<div class="container-fluid py-4">
  <div class="py-4 text-center">
    <h1 data-test-id="create-community-title">
      {{ 'CREATE_COMMUNITY_TITLE' | translate }}
    </h1>
  </div>
  <div *ngIf="formContent$ | async as content" class="row justify-content-md-center">
    <div class="col-md-8">
      <ng-container *ngIf="focusState$ | async as field">
        <app-community-focus
          [value]="field.value"
          [hidden]="field.hidden"
          [disabled]="field.disabled"
          (focusChanged)="onCommunityFocusChanged($event)"
        ></app-community-focus>
      </ng-container>
      <app-form-constructor [formContent]="content"></app-form-constructor>
      <small class="form-text text-muted required-hint" data-test-id="small-required">
        * - {{ 'REQUIRED_FIELD_HINT' | translate }}
      </small>
      <div class="py-4">
        <button
          appLongOperation
          class="btn btn-primary me-3"
          type="submit"
          data-test-id="btn-create-community"
          (click)="submitForm($event)"
        >
          {{ 'BTN_SUBMIT_HINT' | translate }}
        </button>
        <button class="btn btn-secondary me-3" type="button" (click)="onCancel()" data-test-id="btn-cancel-community">
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
